import * as types from "../actions/types";



const initialState = {
  cultureList: [],
  loading: false
};


export default function culture (state = initialState, action) {
  switch (action.type) {
    case types.GET_CULTURE:
      return {
        ...state,
        cultureList: action.payload,
      };
    case types.GET_CULTURE_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
}
